import { render, staticRenderFns } from "./LisansKisitBar.vue?vue&type=template&id=24524662&scoped=true"
import script from "./LisansKisitBar.vue?vue&type=script&lang=ts"
export * from "./LisansKisitBar.vue?vue&type=script&lang=ts"
import style0 from "./LisansKisitBar.vue?vue&type=style&index=0&id=24524662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24524662",
  null
  
)

export default component.exports